"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var i18next_1 = __importDefault(require("i18next"));
var core_1 = require("@material-ui/core");
var empty_graphic_svg_1 = __importDefault(require("@assets/components/directory/empty-search-graphic/empty-graphic.svg"));
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a;
    return (0, core_1.createStyles)({
        root: (_a = {
                display: 'flex',
                flexDirection: 'column',
                marginTop: theme.spacing(8),
                alignItems: 'center'
            },
            _a[theme.breakpoints.up('md')] = {
                marginTop: theme.spacing(16),
            },
            _a),
        emptyStateGraphic: {
            marginTop: '48px',
            marginBottom: '76px',
            position: 'relative',
            zIndex: -1,
        },
        emptyStateBodyText: {
            marginTop: '8px',
            textAlign: 'center',
            padding: '10px',
        },
    });
});
/**
 * @component Default display component in place of search result.
 */
var EmptyStateGraphic = function () {
    var classes = useStyles();
    var theme = (0, core_1.useTheme)();
    var isMobileView = (0, core_1.useMediaQuery)(theme.breakpoints.down('sm'));
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement(core_1.Typography, { variant: isMobileView ? 'h5' : 'h3' }, "What link are you looking for?"),
        react_1.default.createElement(core_1.Typography, { variant: "body1", className: classes.emptyStateBodyText },
            "Search by keyword or email to see what links other",
            ' ',
            i18next_1.default.t('general.officerType'),
            " ",
            react_1.default.createElement("br", null),
            "have created, and find link owners. The directory is only available",
            ' ',
            react_1.default.createElement("br", null),
            "to users who are signed in."),
        react_1.default.createElement("div", { className: classes.emptyStateGraphic },
            react_1.default.createElement("img", { src: empty_graphic_svg_1.default, alt: "empty search graphic" }))));
};
exports.default = EmptyStateGraphic;
